import { LocalAction, LocalActionType } from '@/app/module/campaigns/types'

import { ActionOption } from './options'

export type ActionError = {
  disabled: boolean
  message: string
}

export const getActionErrors = (
  actions: LocalAction[],
  allowedOptions: ActionOption[] = [],
): Array<ActionError | undefined> => {
  const optionsMap: Record<LocalActionType, ActionOption> = allowedOptions.reduce(
    (acc, option) => ({
      ...acc,
      [option.value]: option,
    }),
    {} as Record<LocalActionType, ActionOption>,
  )

  return actions.map((action) => {
    const { type } = action
    const option = optionsMap[type]

    if (!option || option.disabled) {
      return {
        disabled: true,
        message: option?.disabledReason || 'This action is not allowed in this list.',
      }
    }

    return undefined
  })
}
